import { ApButtonSecondary } from '@alixpartners/ui-components';
import React, { useContext, useEffect, useState } from 'react';
import { Wrapper, TextContainer, TableHeading } from './FileUplodError.styles';
import { filesProcesing } from 'utils/apiRequests';
import { GenerateSpendCubeContext } from 'contexts/GenerateSpendCubeContext';
import ProcessingFilesList from '../ProcessingFilesList/ProcessingFilesList';
const FileUploadError = ({ errorMessage, setCurrentLoadingMessage }) => {
	const context = useContext(GenerateSpendCubeContext);
	const { setIsShowRestartModal } = context;
	const [data, setData] = useState([]);

	useEffect(() => {
		filesProcesing()
			.then(res => {
				if (res?.succeeded && res?.data?.length !== 0) {
					setData(res?.data);
				}
			})
			.catch(err => {
				console.error(err);
			});
	}, []);

	const restartUploading = () => {
		setCurrentLoadingMessage({
			message: 'ETL process is being restarted',
			text: '',
		});
		setIsShowRestartModal(true);
	};

	return (
		<Wrapper>
			<TextContainer>{errorMessage}</TextContainer>
			<ApButtonSecondary
				style={{ color: 'orange', borderColor: 'orange' }}
				onClick={restartUploading}
			>
				Restart
			</ApButtonSecondary>
			<TableHeading>Uploaded Files:</TableHeading>
			{data?.length !== 0 && <ProcessingFilesList filesList={data} />}
		</Wrapper>
	);
};

export default FileUploadError;
